import type { AppRouter } from '@buyerflo/functions'
import { QueryClient } from '@tanstack/react-query'
import { createTRPCContext } from '@trpc/tanstack-react-query'

const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>()

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 60_000,
            retry: 1,
        },
    },
})

export { TRPCProvider, useTRPC, useTRPCClient }
